export enum PassengerMapStationFilterTypeEnum {
  allPickUpStations = "allPickUpStations",
  allSelectedPassengersPickupStations = "allSelectedPassengersPickupStations",
  allSelectedPassengersAreasPickUpStations = "allSelectedPassengersAreasPickUpStations",
}

export enum FilterStationFormFieldsEnum {
  filterType = "filterType",
}

export enum LinkStationFormFieldsEnum {
  pickupStation = "pickupStation",
  homeAddresses = "homeAddresses",
}

export enum AddStationFormFieldsEnum {
  Addresses = "address",
}

export enum AddBulkStationMethodEnum {
  walkTime = "walkTime",
  distanceInMeters = "distanceInMeters",
}

export enum AddBulkStationFormFieldsEnum {
  method = "method",
  value = "value",
  isSetOnlyForMissingPickup = "isSetOnlyForMissingPickup",
}

export enum PassengerMapControlsEnum {
  filterStations = "filterStations",
  addOneNewStation = "addOneNewStation",
  addBulkNewStation = "addBulkNewStation",
  linkStations = "linkStations",
}
